// packages/main/src/setup.ts
import "@solid-devtools/debugger/setup";
import {
  setClientVersion,
  setSolidVersion
} from "@solid-devtools/debugger/setup";
import {
  setLocatorOptions,
  setElementInterface
} from "@solid-devtools/debugger/setup";
setClientVersion("0.34.5");
setSolidVersion("1.9.7", "1.9.0");

export {
  setLocatorOptions,
  setElementInterface
};
